// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none,ts_nocheck=true"
// @generated from file pull_requests/v1/development.proto (package github.pull_requests.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file pull_requests/v1/development.proto.
 */
export const file_pull_requests_v1_development: GenFile = /*@__PURE__*/
  fileDesc("CiJwdWxsX3JlcXVlc3RzL3YxL2RldmVsb3BtZW50LnByb3RvEhdnaXRodWIucHVsbF9yZXF1ZXN0cy52MSJSChNEZXZlbG9wbWVudFJlc3BvbnNlEjsKDWxpbmtlZF9pc3N1ZXMYASADKAsyJC5naXRodWIucHVsbF9yZXF1ZXN0cy52MS5MaW5rZWRJc3N1ZSIpCgpSZXBvc2l0b3J5Eg0KBW93bmVyGAEgASgJEgwKBG5hbWUYAiABKAki8wEKC0xpbmtlZElzc3VlEgoKAmlkGAEgASgDEg4KBm51bWJlchgCIAEoBRINCgV0aXRsZRgDIAEoCRILCgN1cmwYBCABKAkSMgoFc3RhdGUYBSABKA4yIy5naXRodWIucHVsbF9yZXF1ZXN0cy52MS5Jc3N1ZVN0YXRlEj8KDHN0YXRlX3JlYXNvbhgGIAEoDjIpLmdpdGh1Yi5wdWxsX3JlcXVlc3RzLnYxLklzc3VlU3RhdGVSZWFzb24SNwoKcmVwb3NpdG9yeRgHIAEoCzIjLmdpdGh1Yi5wdWxsX3JlcXVlc3RzLnYxLlJlcG9zaXRvcnkqVwoKSXNzdWVTdGF0ZRIbChdJU1NVRV9TVEFURV9VTlNQRUNJRklFRBAAEhQKEElTU1VFX1NUQVRFX09QRU4QARIWChJJU1NVRV9TVEFURV9DTE9TRUQQAiq/AQoQSXNzdWVTdGF0ZVJlYXNvbhIiCh5JU1NVRV9TVEFURV9SRUFTT05fVU5TUEVDSUZJRUQQABIgChxJU1NVRV9TVEFURV9SRUFTT05fQ09NUExFVEVEEAESIAocSVNTVUVfU1RBVEVfUkVBU09OX0RVUExJQ0FURRACEiIKHklTU1VFX1NUQVRFX1JFQVNPTl9OT1RfUExBTk5FRBADEh8KG0lTU1VFX1NUQVRFX1JFQVNPTl9SRU9QRU5FRBAEYgZwcm90bzM");

/**
 * Response payload for
 * GET /:owner/:repo/pull/:number/page_data/development
 *
 * Defined by PullRequests::PageData::SharedController#development.
 *
 * @generated from message github.pull_requests.v1.DevelopmentResponse
 */
export type DevelopmentResponse = Message<"github.pull_requests.v1.DevelopmentResponse"> & {
  /**
   * @generated from field: repeated github.pull_requests.v1.LinkedIssue linked_issues = 1;
   */
  linkedIssues: LinkedIssue[];
};

/**
 * Describes the message github.pull_requests.v1.DevelopmentResponse.
 * Use `create(DevelopmentResponseSchema)` to create a new message.
 */
export const DevelopmentResponseSchema: GenMessage<DevelopmentResponse> = /*@__PURE__*/
  messageDesc(file_pull_requests_v1_development, 0);

/**
 * @generated from message github.pull_requests.v1.Repository
 */
export type Repository = Message<"github.pull_requests.v1.Repository"> & {
  /**
   * @generated from field: string owner = 1;
   */
  owner: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;
};

/**
 * Describes the message github.pull_requests.v1.Repository.
 * Use `create(RepositorySchema)` to create a new message.
 */
export const RepositorySchema: GenMessage<Repository> = /*@__PURE__*/
  messageDesc(file_pull_requests_v1_development, 1);

/**
 * @generated from message github.pull_requests.v1.LinkedIssue
 */
export type LinkedIssue = Message<"github.pull_requests.v1.LinkedIssue"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: int32 number = 2;
   */
  number: number;

  /**
   * @generated from field: string title = 3;
   */
  title: string;

  /**
   * @generated from field: string url = 4;
   */
  url: string;

  /**
   * @generated from field: github.pull_requests.v1.IssueState state = 5;
   */
  state: IssueState;

  /**
   * @generated from field: github.pull_requests.v1.IssueStateReason state_reason = 6;
   */
  stateReason: IssueStateReason;

  /**
   * @generated from field: github.pull_requests.v1.Repository repository = 7;
   */
  repository?: Repository;
};

/**
 * Describes the message github.pull_requests.v1.LinkedIssue.
 * Use `create(LinkedIssueSchema)` to create a new message.
 */
export const LinkedIssueSchema: GenMessage<LinkedIssue> = /*@__PURE__*/
  messageDesc(file_pull_requests_v1_development, 2);

/**
 * Open/closed state of a linked issue. The legacy JSON encodes this as the
 * upper-cased state string ("OPEN"/"CLOSED").
 *
 * @generated from enum github.pull_requests.v1.IssueState
 */
export enum IssueState {
  /**
   * @generated from enum value: ISSUE_STATE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ISSUE_STATE_OPEN = 1;
   */
  OPEN = 1,

  /**
   * @generated from enum value: ISSUE_STATE_CLOSED = 2;
   */
  CLOSED = 2,
}

/**
 * Describes the enum github.pull_requests.v1.IssueState.
 */
export const IssueStateSchema: GenEnum<IssueState> = /*@__PURE__*/
  enumDesc(file_pull_requests_v1_development, 0);

/**
 * Why a linked issue is in its current state. UNSPECIFIED represents the
 * legacy JSON null (no reason recorded).
 *
 * @generated from enum github.pull_requests.v1.IssueStateReason
 */
export enum IssueStateReason {
  /**
   * @generated from enum value: ISSUE_STATE_REASON_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ISSUE_STATE_REASON_COMPLETED = 1;
   */
  COMPLETED = 1,

  /**
   * @generated from enum value: ISSUE_STATE_REASON_DUPLICATE = 2;
   */
  DUPLICATE = 2,

  /**
   * @generated from enum value: ISSUE_STATE_REASON_NOT_PLANNED = 3;
   */
  NOT_PLANNED = 3,

  /**
   * @generated from enum value: ISSUE_STATE_REASON_REOPENED = 4;
   */
  REOPENED = 4,
}

/**
 * Describes the enum github.pull_requests.v1.IssueStateReason.
 */
export const IssueStateReasonSchema: GenEnum<IssueStateReason> = /*@__PURE__*/
  enumDesc(file_pull_requests_v1_development, 1);

import { registerSchemaHash } from "../../../schema-hash-registry";
registerSchemaHash(DevelopmentResponseSchema, "1232a3d72890")
registerSchemaHash(RepositorySchema, "c5c51727fceb")
registerSchemaHash(LinkedIssueSchema, "c12be7cfde77")
